
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/account/communication-preferences",
      function () {
        return require("private-next-pages/members/account/communication-preferences/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/account/communication-preferences"])
      });
    }
  